import {
  LOGIN_ACTION,
  LOGOUT_ACTION,
  SET_LOGIN_DETAILS,
  SET_PROFILE_IMAGE,
  IS_CHANGE_PASSWORD_SUCCESS,
} from "./Constants";
import { API_RESPONSE_STATUS_CODES, API } from "../Utils/Constants";
import { callAPI } from "../config/AxiosTemplate";

export const loginAction = (userName, password, callback) => (dispatch) => {
  let data = "username=" + userName + "&password=" + password;
  callAPI("Login", API.login, "POST", data, (apiResponse) => {
    if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
      dispatch({
        type: LOGIN_ACTION,
        data: apiResponse.data.data,
      });
    }
    callback(apiResponse.data);
  });
};

export const logoutAction = (callback) => (dispatch) => {
  callAPI("Logout", API.logout, "POST", {}, (apiResponse) => {
    if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
      dispatch({
        type: LOGOUT_ACTION,
        data: {},
      });
    }
    callback(apiResponse.data);
  });
};

export const forgotPasswordAction = (requestData, callback) => {
  callAPI(
    "ForgotPassword",
    API.forgotPassword,
    "POST",
    { username: requestData },
    (apiResponse) => {
      callback(apiResponse.data);
    }
  );
};

export function setLoginDetails(userDetails) {
  return {
    type: SET_LOGIN_DETAILS,
    data: userDetails,
  };
}

export function setProfileImage(profileImageData) {
  return {
    type: SET_PROFILE_IMAGE,
    data: profileImageData,
  };
}

export function setIsChangePasswordSuccess(isChangePasswordSuccess) {
  return {
    type: IS_CHANGE_PASSWORD_SUCCESS,
    data: isChangePasswordSuccess,
  };
}
